import { render } from "./FloatCreate.vue?vue&type=template&id=88805b3c"
import script from "./FloatCreate.vue?vue&type=script&lang=js"
export * from "./FloatCreate.vue?vue&type=script&lang=js"

import "./FloatCreate.vue?vue&type=style&index=0&id=88805b3c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__